<script>
import { get } from 'lodash';
import { MenuItem } from 'element-ui';

export default {
  name: 'nuttrema-el-menu-item',
  mixins: [MenuItem],
  props: {
    type: {
      required: true,
      default: null,
    },
  },
  computed: {
    active() {
      const path = get(this.$route, 'path', '');
      // console.log('nuttrema-el-menu-item', this.index, path);
      if (this.type === 'parent') return this.index === path || path.startsWith(this.index);
      return this.index === path;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/navigation/nuttrema-el-menu-item.vue